import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {deepCopy} from "../../../lib/utils";
import {SeriesHtmlFormComponent} from "../series-html-form/series-html-form.component";
import {COMMON_DIALOG_IMPORTS} from "../../../shared/import-groups/Common";
import {CommonModule} from "@angular/common";

export interface DialogData {
    form_result: string;
    config: { paragraph_body: any };
}

@Component({
    selector: 'custom-html-text-form',
    templateUrl: './custom-html-text-form.component.html',
    imports: [
        SeriesHtmlFormComponent,
        COMMON_DIALOG_IMPORTS,
        CommonModule
    ],
    styleUrls: ['./custom-html-text-form.component.less']
})
export class CustomHtmlTextFormComponent implements OnInit {
    showing_hints: boolean = false;
    customText: string;

    constructor(private dialogRef: MatDialogRef<CustomHtmlTextFormComponent>,
                @Inject(MAT_DIALOG_DATA) private dialogData: DialogData) {
        this.customText = deepCopy(this.dialogData.config.paragraph_body);
    }

    ngOnInit() {

    }

    save() {
        this.dialogRef.close({paragraph_body: this.customText});
    }

    onCloseClick(): void {
        this.dialogRef.close();
    }

}
